import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { SignedIn, SignedOut, SignIn, SignUp } from '@clerk/clerk-react'

// Pages
import NewLandingPage from './pages/NewLandingPage'
import DashboardPage from './pages/DashboardPage'
import UploadPage from './pages/UploadPage'
import StatementDetailsPage from './pages/StatementDetailsPage'
import { PrivacyPage } from './pages/PrivacyPage'

// Components
import { CookieConsent } from './components/CookieConsent'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<NewLandingPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/sign-in" element={
          <>
            <SignedOut>
              <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
              </div>
            </SignedOut>
            <SignedIn>
              <Navigate to="/dashboard" replace />
            </SignedIn>
          </>
        } />
        <Route path="/sign-up" element={
          <>
            <SignedOut>
              <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
              </div>
            </SignedOut>
            <SignedIn>
              <Navigate to="/dashboard" replace />
            </SignedIn>
          </>
        } />

        {/* Protected Routes */}
        <Route path="/dashboard" element={
          <SignedIn>
            <DashboardPage />
          </SignedIn>
        } />
        <Route path="/upload" element={
          <SignedIn>
            <UploadPage />
          </SignedIn>
        } />
        <Route path="/statements/:id" element={
          <SignedIn>
            <StatementDetailsPage />
          </SignedIn>
        } />

        {/* Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Cookie Consent Banner (shows globally) */}
      <CookieConsent />
    </BrowserRouter>
  )
}

export default App
